import { PRICE_POLICIES_SET_DISABLED_BOX_ALERT } from '../constants'

export function reducer(state, action) {
    if (action.type === PRICE_POLICIES_SET_DISABLED_BOX_ALERT) {
        return {
            ...state,
            isEnabledBoxAlert: action.data.isEnabledBoxAlert,
        }
    } else {
        return state
    }
}